import {
  BookWidgetFields,
  BookWidgetFieldUpdateEvent
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { createAction, props } from '@ngrx/store';
import { FlightShopWidgetTemplates } from '../../constants/flight-shop.constants';

export enum BookWidgetActionTypes {
  setFlightShopTemplateType = '[flight-shop book widget] set template type',
  triggerInitFields = '[flight-shop book widget] trigger init fields',
  initBookWidgetFields = '[flight-shop book widget] init book widget fields default values',
  applyBookWidgetFieldChangeRules = '[flight-shop book widget] apply book widget field change rules',
  bookWidgetFieldChange = '[flight-shop book widget] book widget field change',
  swapAirports = '[flight-shop book widget] swap airports',
  addFlightsForMc = '[flight-shop book widget] add flight for mc',
  removeFlightForMc = '[flight-shop book widget] remove flight for mc',
  recentSearchItemSelected = '[flight-shop book widget] recent search item selected',
  initPredictiveSearch = '[flight-shop book widget] predictive search string',
  updateFieldsFromRecentSearch = '[flight-shop book widget] update book widget from recent search',
  findFlightInitiated = '[flight-shop book widget] find flight initiated',
  findFlightProceed = '[flight-shop book widget] find flight proceed',
  setFieldsAfterValidation = '[flight-shop book widget] set fields after validation',
  savedSearchItemSelected = '[flight-shop book widget] saved search item selected',
  updateFieldsFromSavedSearch = '[flight-shop book widget] update book widget from saved search',
  searchModalOpened = '[flight-shop book widget] search modal opened',
  updateBookWidgetFieldsFromFlex = '[flight-shop book widget] update book widget fields from flex pages'
}

export const TriggerInitFields = createAction(
  BookWidgetActionTypes.triggerInitFields
);

export const SetFlightShopTemplateType = createAction(
  BookWidgetActionTypes.setFlightShopTemplateType,
  props<{ templateType: FlightShopWidgetTemplates }>()
);

export const InitBookWidgetFields = createAction(
  BookWidgetActionTypes.initBookWidgetFields,
  props<{ bookWidgetFields: BookWidgetFields }>()
);

export const ApplyBookWidgetFieldChangeRules = createAction(
  BookWidgetActionTypes.applyBookWidgetFieldChangeRules,
  props<{
    bookWidgetFields: BookWidgetFields;
    bookWidgetFieldUpdateEvent: BookWidgetFieldUpdateEvent;
  }>()
);

export const BookWidgetFieldChange = createAction(
  BookWidgetActionTypes.bookWidgetFieldChange,
  props<{
    bookWidgetFieldUpdateEvent: BookWidgetFieldUpdateEvent;
  }>()
);

export const SwapAirports = createAction(
  BookWidgetActionTypes.swapAirports,
  props<{
    flightIndex: number;
  }>()
);

export const AddFlightsForMc = createAction(
  BookWidgetActionTypes.addFlightsForMc
);

export const RemoveFlightForMc = createAction(
  BookWidgetActionTypes.removeFlightForMc
);

export const RecentSearchItemSelected = createAction(
  BookWidgetActionTypes.recentSearchItemSelected,
  props<{
    index: number;
  }>()
);

export const InitPredictiveSearch = createAction(
  BookWidgetActionTypes.initPredictiveSearch,
  props<{
    predictiveSearchString: string;
  }>()
);

export const UpdateFieldsFromRecentSearch = createAction(
  BookWidgetActionTypes.updateFieldsFromRecentSearch,
  props<{ bookWidgetFields: BookWidgetFields }>()
);
export const SavedSearchItemSelected = createAction(
  BookWidgetActionTypes.savedSearchItemSelected,
  props<{
    index: number;
  }>()
);

export const UpdateFieldsFromSavedSearch = createAction(
  BookWidgetActionTypes.updateFieldsFromSavedSearch,
  props<{ bookWidgetFields: BookWidgetFields }>()
);
export const FindFlightInitiated = createAction(
  BookWidgetActionTypes.findFlightInitiated
);

export const FindFlightProceed = createAction(
  BookWidgetActionTypes.findFlightProceed
);

export const SetFieldsAfterValidation = createAction(
  BookWidgetActionTypes.setFieldsAfterValidation,
  props<{ bookWidgetFields: BookWidgetFields; fieldsErrorCount: number }>()
);

export const SearchModalOpened = createAction(
  BookWidgetActionTypes.searchModalOpened
);

export const UpdateBookWidgetFieldsFromFlex = createAction(
  BookWidgetActionTypes.updateBookWidgetFieldsFromFlex,
  props<{
    dates?: { departureDate: string; returnDate: string };
    originAirportCode?: string;
    destinationAirportCode?: string;
  }>()
);
